module.exports = __webpack_public_path__ + "img/r1_jixingzhanjia.d0334a1c.jpg";